import Request from "./request";
const merchantCodeDefault = "RAGTTDK_HCMTAX";

export default class TorichatService {
  static async getList(data, merchantCode) {
    return new Promise((resolve, reject) => {
      Request.send({
        method: "POST",
        path: "/ChatPlatform/getMessagesHistory",
        data: data,
        newUrl: process.env.REACT_APP_API_TORICHAT_URL,
        headers: {
          merchantCode: merchantCode,
        },
      }).then((result = {}) => {
        const { statusCode } = result;
        if (statusCode === 200) {
          return resolve(result.data);
        } else {
          return reject();
        }
      });
    });
  }

  static async update(data, merchantCode) {
    return new Promise((resolve, reject) => {
      Request.send({
        method: "POST",
        path: "/ChatPlatform/updateMessage",
        data: data,
        newUrl: process.env.REACT_APP_API_TORICHAT_URL,
        headers: {
          merchantCode: merchantCode,
        },
      }).then((result = {}) => {
        const { statusCode } = result;
        if (statusCode === 200) {
          return resolve(result.data);
        } else {
          return reject();
        }
      });
    });
  }

  static async syncKnowledge(data) {
    return new Promise((resolve, reject) => {
      Request.send({
        method: "POST",
        path: "/TorichatMappingExpertKnowledge/advanceUser/syncExpertKnowledge",
        data: data,
      }).then((result = {}) => {
        const { statusCode } = result;
        if (statusCode === 200) {
          return resolve({ isSuccess: true, ...result });
        } else {
          return resolve({ isSuccess: false, ...result });
        }
      });
    });
  }

  static async syncGeneralInfo(data) {
    return new Promise((resolve, reject) => {
      Request.send({
        method: "POST",
        path: "/TorichatMappingGeneralInfo/advanceUser/syncStationInfo",
        data: data,
      }).then((result = {}) => {
        const { statusCode } = result;
        if (statusCode === 200) {
          return resolve({ isSuccess: true, ...result });
        } else {
          return resolve({ isSuccess: false, ...result });
        }
      });
    });
  }

  static async getConversation(data, merchantCode) {
     return new Promise((resolve, reject) => {
      Request.send({
        method: "POST",
        path: "/ChatPlatform/getConversationList",
        data: data,
        newUrl: process.env.REACT_APP_API_TORICHAT_URL,
        headers: {
          merchantCode: merchantCode,
        },
      }).then((result = {}) => {
        const { statusCode } = result;
        if (statusCode === 200) {
          return resolve(result.data);
        } else {
          return reject();
        }
      });
    });
  }
}
